import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { PaginationEvent } from 'src/app/commons/interfaces';
import { MechanicsService } from 'src/app/commons/_services/mechanics.service';
import { PreferencesService } from 'src/app/commons/_services/preferences.service';
import { QueryParamsService } from 'src/app/commons/_services/queryParams.service';
import { SearchService } from 'src/app/commons/_services/search.service';

@Component({
	selector: 'results-list-gdd',
	templateUrl: './results-list.component-gdd.html',
	styleUrls: ['./results-list.component-gdd.css'],
	// encapsulation: ViewEncapsulation.None, No need, I think?
	standalone: false
})
export class GDDResultsListComponent implements OnInit, OnDestroy {

	@Input() docs: any[] = []

	public selectedThumbnailImgIndex:number[] = []
	public noVerbalElement: string = ''; // to display if !result.human.designDescription
	private resultsVisibilitySubscription: Subscription;
	
	constructor(
		public ms: MechanicsService,
		public ss: SearchService,
		public ps: PreferencesService,
		private qs: QueryParamsService,
		private changeDetector: ChangeDetectorRef) {
		this.resultsVisibilitySubscription = this.ss.resultsVisibilityChanges.subscribe(() => {
			this.changeDetector.markForCheck();
		});
	}

	ngOnInit(): void {
		this.noVerbalElement = this.ms.translate('search_results.no_verbal_elements')
		for(let i=0; i<this.docs.length;i++){
			this.selectedThumbnailImgIndex.push(0)
		}
	}

	ngOnDestroy(): void {
		this.resultsVisibilitySubscription.unsubscribe();
	}

	onPagination(pageChangeEvent: PaginationEvent) {

		const l = `resultList onPAgination() - `

		/*
			Receiving : 
			{
				currentPage: 2,
				skip: 10
			}
	
			I need : 
				- &start=10 ( = skip)


			*/

		// console.log(`${l}pageChangeEvent = `, pageChangeEvent)

		this.qs.setQP("start", pageChangeEvent.skip)

		this.qs.queryParamsObjectToUrl()

	}


	onSelectAllChecked($event) {

		const l = `onSelectAllChecked() - `

		const isChecked: boolean = $event.target.checked

		for (let doc of this.docs) {
			doc.selected = isChecked
			this.wasSelected(doc.st13, isChecked)
		}
	}

	get isAllSelected() {
		return this.docs?.every(doc => doc.selected)
	}

	wasSelected(st13, selected): void{
		if (selected){
			this.ms.addToCache(st13)
		}
		else{
			this.ms.removeFromCache(st13)
		}
	}

	get parent() {
		return this
	}
	details(doc, idx) {

		const l = `resultsComponent details() - `


		// console.log(`${l}idx=`, idx)


		let st13 = doc.st13
		let st13Root = doc.st13Root
		if (st13Root ){
			console.log("St13: " + st13 + " parent: "+ doc.st13Root);
		}
		this.ms.addToViewedCache(st13)
		this.docs[idx].viewed = 'viewed'
		this.ss.searchResult.setCursor(idx)
		// to be changes with next/prev buttons to force page reload
		// we do not change '_' here as it is being used as a query identifier
		this.qs.setQP('i', idx)

		let route = this.ms.makeRoute({ path: this.ms.endpoint, subpath: `design/${st13}`, caller: l })
		if (st13Root){
			route = this.ms.makeRoute({ path: this.ms.endpoint, subpath: `design/${st13Root}`, caller: l })
		}
		this.qs.queryParamsObjectToUrl(route)
	}

	hasLogo(result): boolean {

		const hasRegularLogo: boolean = result.logo && result.logo[0] && result.logo[0].length > 0;
		const hasDummyLogo = result.dummyLogo && result.dummyLogo.length > 0

		return hasRegularLogo || hasDummyLogo;
	}

	changeImage(event:number[]){
		this.selectedThumbnailImgIndex[event[1]] = event[0]
	}
}
